import { Box, Button, Heading, Text, VStack, Link, HStack, Icon } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { IconType } from "react-icons";
import { FaInstagram, FaTiktok } from "react-icons/fa";

const MotionBox = motion(Box);
const mercadoLivreLink = "https://www.mercadolivre.com.br/pagina/sedapecosmetico";
const tiktokLink = "https://www.tiktok.com/@sedapecosmeticos?_r=1&_t=ZS-96MbToOEhiT";

export default function Footer() {
  const ChakraIcon = (icon: IconType) => icon as unknown as React.ElementType;
  
  return (
    <MotionBox
      bg="sedapeGold"
      color="white"
      py={20}
      textAlign="center"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      textColor="#212121"
    >
      <VStack spacing={6}>
        <Heading>Pés Incrivelmente Macios?</Heading>
        <Text maxW={{ base: "2xl", sm: "sm" }} fontSize="lg">
          Transforme sua rotina diária em um ritual luxuoso. O creme para os pés Sedapé Cosmetics
          é a sua solução para hidratação duradoura e pele aveludada.
        </Text>
        <Button
          bg="sedapePink"
          color="white"
          size="lg"
          _hover={{ bg: "sedapePinkDark" }}
          as="a"
          href={mercadoLivreLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          Comprar pelo Mercado Livre
        </Button>
        <HStack spacing={4} flexDir={{ base: "column", md: "row" }}>
          <Link href="https://www.instagram.com/sedapecosmeticos/" isExternal display="flex" alignItems="center">
            <Icon as={ChakraIcon(FaInstagram)} w={6} h={6} mr={2} />
            @sedapecosmeticos
          </Link>
          <Link href={tiktokLink} isExternal display="flex" alignItems="center">
            <Icon as={ChakraIcon(FaTiktok)} w={6} h={6} mr={2} />
            @sedapecosmeticos
          </Link>
        </HStack>
      </VStack>
      <Text mt={10} fontSize="sm" opacity={0.8} textColor="#000">
        © {new Date().getFullYear()} Sedapé Cosmetics. Todos os direitos reservados.
      </Text>
    </MotionBox>
  );
}
